export default "__VITE_ASSET__DULrk1mr__"